<template>
  <div class="prize-manage">
    <header class="page-header">
      <h2 class="page-header__title">奖品管理</h2>
    </header>

    <!-- 搜索区域 -->
    <el-form :inline="true" :model="queryForm" class="search-form">
      <el-form-item label="奖品ID">
        <el-input
          v-model="queryForm.prizeId"
          placeholder="ID精确搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="奖品名称">
        <el-input
          v-model="queryForm.prizeName"
          placeholder="名称模糊搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="奖品类型">
        <el-select
          v-model="queryForm.prizeType"
          placeholder="请选择奖品类型"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="站内会员" :value="0"></el-option>
          <el-option label="头像挂件" :value="1"></el-option>
          <el-option label="主题" :value="2"></el-option>
          <el-option label="电子证书" :value="3"></el-option>
          <el-option label="电子奖牌" :value="4"></el-option>
          <el-option label="实物奖励" :value="5"></el-option>
          <el-option label="外链奖励" :value="6"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="queryForm.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="停用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表区域 -->
    <div class="pagination">
      <el-button type="primary" size="small" @click="handleAdd"
        >新增奖品</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="prizeId"
        label="奖品ID"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="prizeName"
        label="奖品名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="prizeType" label="奖品类型" align="center">
        <template scope="{ row }">
          <span>{{ prizeTypeText(row.prizeType) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="奖品详情" align="center">
        <template scope="{ row }">
          <div v-if="row.detailType === 'text'" class="detail-text">
            <span>{{ row.detailContent }}</span>
          </div>
          <div v-else-if="row.detailType === 'image'" class="detail-image">
            <img
              :src="row.detailContent"
              class="detail-img"
              @click="previewImage(row.detailContent)"
            />
          </div>
          <div v-else-if="row.detailType === 'multiImage'" class="detail-icons">
            <img
              v-for="(url, idx) in row.detailContent"
              :key="idx"
              :src="url"
              class="detail-icon-img"
              @click="previewImage(url)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template scope="{ row }">
          <span
            :class="row.status === 1 ? 'status-enabled' : 'status-disabled'"
          >
            {{ row.status === 1 ? "启用" : "停用" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template scope="{ row }">
          <el-button type="text" @click="handleView(row)">查看</el-button>
          <el-button
            v-if="row.status === 1"
            type="text"
            @click="handleChangeStatus(row, 0)"
            >停用</el-button
          >
          <el-button v-else type="text" @click="handleChangeStatus(row, 1)"
            >启用</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="queryForm.pageNum"
      :page-size="queryForm.pageSize"
      layout="prev, pager, next, jumper"
      :total="tableTotal"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 新增奖品弹窗 -->
    <el-dialog
      title="新增奖品"
      v-model="addDialogVisible"
      size="small"
      :modal-append-to-body="false"
      @close="resetAddForm"
    >
      <el-form :model="addForm" label-width="100px" class="add-form">
        <el-form-item label="奖品名称">
          <el-input
            v-model="addForm.prizeName"
            placeholder="请输入奖品名称，不超过20个字"
            class="same-width-input"
            :maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="奖品类型">
          <el-select
            v-model="addForm.prizeType"
            class="same-width-input"
            placeholder="请选择奖品类型"
            @change="onPrizeTypeChange"
          >
            <el-option label="站内会员" :value="0"></el-option>
            <el-option label="头像挂件" :value="1"></el-option>
            <el-option label="主题" :value="2"></el-option>
            <el-option label="电子证书" :value="3"></el-option>
            <el-option label="电子奖牌" :value="4"></el-option>
            <el-option label="实物奖励" :value="5"></el-option>
            <el-option label="外链奖励" :value="6"></el-option>
          </el-select>
        </el-form-item>

        <!-- 站内会员 -->
        <template v-if="addForm.prizeType === 0">
          <el-form-item label="选择赠送卡">
            <el-select
              v-model="addForm.cardRefId"
              placeholder="请选择赠送卡"
              class="same-width-input"
            >
              <el-option
                v-for="item in privilegeConfigList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>

        <!-- 头像挂件 -->
        <template v-if="addForm.prizeType === 1">
          <el-form-item label="奖品详情">
            <el-button type="text" @click="handleSelectAvatar"
              >选择头像挂件</el-button
            >
            <div v-if="addForm.avatarUrl" class="selected-preview">
              <img :src="addForm.avatarUrl" class="selected-img" />
              <span class="selected-name">{{ addForm.avatarName }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="type-warning">
              若在【个性化组件】中修改头像挂件，奖牌将被同步变更。
            </div>
          </el-form-item>
        </template>

        <!-- 主题 -->
        <template v-if="addForm.prizeType === 2">
          <el-form-item label="奖品详情">
            <el-button type="text" @click="handleSelectTheme"
              >选择主题</el-button
            >
            <div v-if="addForm.themeUrl" class="selected-preview">
              <img :src="addForm.themeUrl" class="selected-img" />
              <span class="selected-name">{{ addForm.themeName }}</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="type-warning">
              若在【个性化组件】中修改主题，奖牌将被同步变更。
            </div>
          </el-form-item>
        </template>

        <!-- 电子证书 -->
        <template v-if="addForm.prizeType === 3">
          <el-form-item>
            <div class="cert-tip">
              电子证书将使用系统默认模板，根据用户报名信息和完赛信息自动生成。
            </div>
          </el-form-item>
        </template>

        <!-- 电子奖牌 -->
        <template v-if="addForm.prizeType === 4">
          <el-form-item label="奖品详情">
            <el-upload
              class="prize-uploader"
              action=""
              :show-file-list="false"
              :auto-upload="false"
              :on-change="onMedalChange"
              accept="image/*"
            >
              <img
                v-if="addForm.medalUrl"
                :src="addForm.medalUrl"
                class="prize-preview"
              />
              <i v-else class="el-icon-plus prize-uploader-icon"></i>
            </el-upload>
            <div class="form-tip">
              建议尺寸：200x200px，支持jpg/png格式，大小不超过2MB
            </div>
          </el-form-item>
        </template>

        <!-- 实物奖励 -->
        <template v-if="addForm.prizeType === 5">
          <el-form-item label="奖品详情">
            <SUpload
              v-model="addForm.physicalUrl"
              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
              :headers="uploadAuthHeaders"
              accept="image/*"
              type="drag"
              :size="50"
              :show-file-list="false"
            />
            <div class="form-tip">尺寸建议35*35，最大50KB，优先SVG其次png</div>
          </el-form-item>
        </template>

        <!-- 外链奖励 -->
        <template v-if="addForm.prizeType === 6">
          <el-form-item label="奖励图片">
            <SUpload
              v-model="addForm.prizeImage"
              actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
              :headers="uploadAuthHeaders"
              accept="image/*"
              type="drag"
              :size="50"
              :show-file-list="false"
            />
            <div class="form-tip">尺寸建议35*35，最大50KB，优先SVG其次png</div>
          </el-form-item>
          <el-form-item label="外链类型">
            <el-select
              v-model="addForm.outerType"
              class="same-width-input"
              placeholder="请选择外链类型"
              @change="onOuterTypeChange"
            >
              <el-option label="微信小程序" :value="7"></el-option>
              <el-option label="跳转URL" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="addForm.outerType === 7">
            <el-form-item label="小程序原始ID">
              <el-input
                v-model="addForm.appId"
                placeholder="请输入小程序原始ID"
                class="same-width-input"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序路径">
              <el-input
                v-model="addForm.path"
                placeholder="请输入小程序路径，如 /pages/index"
                class="same-width-input"
              ></el-input>
            </el-form-item>
          </template>
          <template v-else-if="addForm.outerType === 5">
            <el-form-item label="跳转URL">
              <el-input
                v-model="addForm.outerUrl"
                placeholder="请输入跳转URL"
                class="same-width-input"
              ></el-input>
            </el-form-item>
          </template>
          <template v-if="addForm.outerType">
            <el-form-item label="是否弹窗提示">
              <el-radio-group v-model="addForm.isPopup">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="addForm.isPopup === 1" label="弹窗内容">
              <el-input
                v-model="addForm.popupContent"
                placeholder="请填写弹窗内容，最多20个字"
                class="same-width-input"
                :maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
            <div v-if="addForm.isPopup === 1" class="popup-prompt-example">
              <span class="popup-prompt-example-label" style="margin-left: 80px"
                >示例</span
              >
              <img
                src="../../../assets/popup-prompt-example.png"
                alt="弹窗示例"
              />
            </div>
          </template>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="confirmAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 选择头像挂件弹窗 -->
    <el-dialog
      title="选择头像挂件"
      v-model="avatarDialogVisible"
      size="small"
      :modal-append-to-body="false"
    >
      <div class="select-dialog-search">
        <el-input
          v-model="avatarSearchName"
          placeholder="名称搜索"
          clearable
          size="small"
          style="width: 200px"
          @keyup.enter.native="onAvatarSearch"
        ></el-input>
        <el-button
          size="small"
          type="primary"
          style="margin-left: 8px"
          @click="onAvatarSearch"
          >搜索</el-button
        >
      </div>
      <el-table
        v-loading="avatarLoading"
        :data="avatarList"
        border
        style="width: 100%"
        @row-click="onAvatarRowClick"
        highlight-current-row
      >
        <el-table-column label="" align="center" width="50">
          <template scope="{ row }">
            <el-radio v-model="selectedAvatarId" :label="row.id"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template scope="{ row }">
            <img :src="row.url" class="select-list-img" />
          </template>
        </el-table-column>
      </el-table>
      <div class="select-dialog-pagination">
        <el-pagination
          :current-page="avatarPageNum"
          :page-size="avatarPageSize"
          :total="avatarTotal"
          layout="prev, pager, next"
          @current-change="onAvatarPageChange"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="avatarDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAvatar">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 选择主题弹窗 -->
    <el-dialog
      title="选择主题"
      v-model="themeDialogVisible"
      size="small"
      :modal-append-to-body="false"
    >
      <div class="select-dialog-search">
        <el-input
          v-model="themeSearchName"
          placeholder="名称搜索"
          clearable
          size="small"
          style="width: 200px"
          @keyup.enter.native="onThemeSearch"
        ></el-input>
        <el-button
          size="small"
          type="primary"
          style="margin-left: 8px"
          @click="onThemeSearch"
          >搜索</el-button
        >
      </div>
      <el-table
        v-loading="themeLoading"
        :data="themeList"
        border
        style="width: 100%"
        @row-click="onThemeRowClick"
        highlight-current-row
      >
        <el-table-column label="" align="center" width="50">
          <template scope="{ row }">
            <el-radio v-model="selectedThemeId" :label="row.id"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column label="图像" align="center" min-width="300">
          <template scope="{ row }">
            <div class="theme-img-list">
              <template v-for="(icon, idx) in row.homeIcon">
                <el-popover
                  v-if="icon.backToTop"
                  :key="'bt' + idx"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img width="300" :src="icon.backToTop" alt="" />
                  <img
                    slot="reference"
                    :src="icon.backToTop"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="icon.iconSelected"
                  :key="'is' + idx"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img width="300" :src="icon.iconSelected" alt="" />
                  <img
                    slot="reference"
                    :src="icon.iconSelected"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="icon.iconNormal"
                  :key="'in' + idx"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img width="300" :src="icon.iconNormal" alt="" />
                  <img
                    slot="reference"
                    :src="icon.iconNormal"
                    class="select-list-img"
                  />
                </el-popover>
              </template>
              <template v-if="row.homeIcon && row.homeIcon[0]">
                <el-popover
                  v-if="row.homeIcon[0].backgroundImage"
                  key="bg"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    :src="row.homeIcon[0].backgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].backgroundImage"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].homeBackgroundImage"
                  key="homebg"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    :src="row.homeIcon[0].homeBackgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].homeBackgroundImage"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].myBackgroundImage"
                  key="mybg"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    :src="row.homeIcon[0].myBackgroundImage"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].myBackgroundImage"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].squareBackgroundUrl"
                  key="sqbg"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    :src="row.homeIcon[0].squareBackgroundUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].squareBackgroundUrl"
                    class="select-list-img"
                  />
                </el-popover>
                <el-popover
                  v-if="row.homeIcon[0].sportBackgroundUrl"
                  key="sportbg"
                  placement="right"
                  title="大图浏览"
                  trigger="hover"
                >
                  <img
                    width="300"
                    :src="row.homeIcon[0].sportBackgroundUrl"
                    alt=""
                  />
                  <img
                    slot="reference"
                    :src="row.homeIcon[0].sportBackgroundUrl"
                    class="select-list-img"
                  />
                </el-popover>
              </template>
              <el-popover
                v-if="row.superscript"
                key="superscript"
                placement="right"
                title="大图浏览"
                trigger="hover"
              >
                <img width="300" :src="row.superscript" alt="" />
                <img
                  slot="reference"
                  :src="row.superscript"
                  class="select-list-img"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="select-dialog-pagination">
        <el-pagination
          :current-page="themePageNum"
          :page-size="themePageSize"
          :total="themeTotal"
          layout="prev, pager, next"
          @current-change="onThemePageChange"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="themeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmTheme">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 停用/启用弹窗 -->
    <el-dialog
      :title="pendingStatus === 0 ? '停用确认' : '启用确认'"
      v-model="disableDialogVisible"
      size="tiny"
      :modal-append-to-body="false"
    >
      <span>{{
        pendingStatus === 0
          ? "确认停用该奖品？停用后该奖品将无法被赛事引用。"
          : "确认启用该奖品？"
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="disableDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="disableLoading"
          @click="confirmDisable"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 图片预览弹窗 -->
    <el-dialog
      title="图片预览"
      v-model="previewVisible"
      size="small"
      :modal-append-to-body="false"
    >
      <img :src="previewSrc" style="width: 100%" />
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog
      title="奖品详情"
      v-model="viewDialogVisible"
      size="small"
      :modal-append-to-body="false"
    >
      <div
        v-if="currentRow"
        class="view-detail"
        v-loading="viewLoading"
        element-loading-text="加载中"
      >
        <div class="view-row">
          <span class="view-label">奖品ID：</span>{{ currentRow.prizeId }}
        </div>
        <div class="view-row">
          <span class="view-label">奖品名称：</span>{{ currentRow.prizeName }}
        </div>
        <div class="view-row">
          <span class="view-label">奖品类型：</span
          >{{ prizeTypeText(currentRow.prizeType) }}
        </div>
        <div class="view-row" v-if="currentRow.prizeType !== 6">
          <span class="view-label">奖品详情：</span>
          <span v-if="currentRow.detailType === 'text'">{{
            currentRow.detailContent
          }}</span>
          <img
            v-else-if="currentRow.detailType === 'image'"
            :src="currentRow.detailContent"
            style="max-width: 200px; max-height: 200px"
          />
          <span
            v-else-if="currentRow.detailType === 'multiImage'"
            class="detail-icons"
          >
            <img
              v-for="(url, idx) in currentRow.detailContent"
              :key="idx"
              :src="url"
              class="detail-icon-img"
              style="cursor: pointer"
              @click="previewImage(url)"
            />
          </span>
        </div>
        <div class="view-row" v-else>
          <div class="view-outer">
            <div>
              <span class="view-label">外链类型：</span>{{ outerTypeText }}
            </div>
            <div v-if="currentRow.detail">
              <span class="view-label">奖励图片：</span>
              <img
                :src="currentRow.detail"
                style="max-width: 200px; max-height: 200px; cursor: pointer"
                @click="previewImage(currentRow.detail)"
              />
            </div>
            <template v-if="currentRow.outerType === 7">
              <div>
                <span class="view-label">小程序原始ID：</span
                >{{ parseOuterDetail(currentRow.outerUrl).appId }}
              </div>
              <div style="white-space: wrap">
                <span class="view-label">小程序路径：</span>
                <span style="word-break: break-all">{{
                  parseOuterDetail(currentRow.outerUrl).path
                }}</span>
              </div>
            </template>
            <template v-else-if="currentRow.outerType === 5">
              <div>
                <span class="view-label">跳转URL：</span
                >{{ currentRow.outerUrl }}
              </div>
            </template>
            <div>
              <span class="view-label">是否弹窗提示：</span
              >{{ currentRow.isPopup === 1 ? "是" : "否" }}
            </div>
            <div v-if="currentRow.isPopup === 1">
              <span class="view-label">弹窗内容：</span
              >{{ currentRow.popupContent }}
            </div>
          </div>
        </div>
        <div class="view-row">
          <span class="view-label">状态：</span
          >{{ currentRow.status === 1 ? "启用" : "停用" }}
        </div>
        <div class="view-row">
          <span class="view-label">创建时间：</span>{{ currentRow.createTime }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SUpload from "../../common/SUpload.vue";

const LOG_TAG = "[PrizeManage]";
const DIY_LIST_URL = "/adminapi/v1/personalizedComponents/list";
// 外链类型映射：1=微信小程序，2=跳转URL
const OUTER_TYPE_MAP = {
  7: "微信小程序",
  5: "跳转URL",
};

export default {
  name: "prizeManage",
  components: { SUpload },
  data() {
    return {
      queryForm: {
        prizeId: "",
        prizeName: "",
        prizeType: "",
        status: "",
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      tableTotal: 0,
      listLoading: false,
      privilegeConfigList: [],
      // 新增奖品
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        prizeName: "",
        prizeType: null,
        cardRefId: null,
        medalUrl: "",
        physicalUrl: "",
        avatarId: null,
        avatarName: "",
        avatarUrl: "",
        themeId: null,
        themeName: "",
        themeUrl: "",
        // 外链奖励
        outerType: null,
        appId: "",
        path: "",
        isPopup: 0,
        popupContent: "",
        prizeImage: "",
        outerUrl: "",
      },
      // 选择头像挂件
      avatarDialogVisible: false,
      avatarList: [],
      avatarLoading: false,
      avatarSearchName: "",
      avatarPageNum: 1,
      avatarPageSize: 10,
      avatarTotal: 0,
      selectedAvatarId: null,
      // 选择主题
      themeDialogVisible: false,
      themeList: [],
      themeLoading: false,
      themeSearchName: "",
      themePageNum: 1,
      themePageSize: 10,
      themeTotal: 0,
      selectedThemeId: null,
      // 停用/启用
      disableDialogVisible: false,
      disableLoading: false,
      pendingStatus: 0,
      // 其他弹窗
      previewVisible: false,
      previewSrc: "",
      viewDialogVisible: false,
      currentRow: null,
      viewLoading: false,
    };
  },
  mounted() {
    this.handleQuery();
  },
  computed: {
    // 查看弹窗中的外链类型文案：命中映射则显示对应名称，未命中则回退为原值，空值显示"未设置"
    outerTypeText() {
      const t = this.currentRow && this.currentRow.outerType;
      if (OUTER_TYPE_MAP[t] !== undefined) return OUTER_TYPE_MAP[t];
      return t || "未设置";
    },
    uploadAuthHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
    },
  },
  methods: {
    isApiSuccess(errorCode) {
      return errorCode === 10000;
    },
    prizeTypeText(type) {
      const map = {
        0: "站内会员",
        1: "头像挂件",
        2: "主题",
        3: "电子证书",
        4: "电子奖牌",
        5: "实物奖励",
        6: "外链奖励",
      };
      return map[type] !== undefined ? map[type] : "未知";
    },
    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(ts);
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    mapRow(r) {
      let detailType = "text";
      let detailContent = r.detail || "";

      if (r.type === 1 || r.type === 4 || r.type === 5) {
        // 头像挂件/电子奖牌/实物奖励：detail 为单张图片 URL
        detailType = "image";
      } else if (r.type === 6) {
        // 外链奖励：detail 现为奖励图片 URL
        detailType = "image";
        detailContent = r.detail || "";
      } else if (r.type === 2) {
        // 主题：detail 为 homeIcon 数组的 JSON 字符串，提取各图片 URL
        try {
          const parsed =
            typeof r.detail === "string" ? JSON.parse(r.detail) : r.detail;
          const icons = Array.isArray(parsed) ? parsed : parsed ? [parsed] : [];
          if (icons.length > 0) {
            const pick = (v) => typeof v === "string" && v;
            const urls = [];
            icons.forEach((icon) => {
              if (pick(icon.backToTop)) urls.push(icon.backToTop);
              if (pick(icon.iconSelected)) urls.push(icon.iconSelected);
              if (pick(icon.iconNormal)) urls.push(icon.iconNormal);
            });
            const first = icons[0];
            [
              "backgroundImage",
              "homeBackgroundImage",
              "myBackgroundImage",
              "squareBackgroundUrl",
              "sportBackgroundUrl",
            ].forEach((key) => {
              if (pick(first[key])) urls.push(first[key]);
            });
            if (urls.length > 0) {
              detailType = "multiImage";
              detailContent = urls;
            }
          }
        } catch (_) {
          // 解析失败降级为文本
        }
      }

      return {
        prizeId: r.id,
        prizeName: r.name,
        prizeType: r.type,
        refId: r.refId,
        detailType,
        detailContent,
        // 外链奖励回显字段
        outerType: r.outerType,
        isPopup: r.isPopup,
        popupContent: r.popupContent,
        appId: r.appId,
        path: r.path,
        detail: r.detail,
        outerUrl: r.outerUrl,
        status: r.status,
        createTime: this.formatTime(r.createTime),
      };
    },
    // 获取站内会员赠送卡下拉选项
    fetchPrivilegeConfigs() {
      this.$http({
        url:
          this.$util.domain +
          "/adminapi/competition/prize/v70310/privilegeConfigs",
        method: "GET",
      })
        .then((res) => {
          const body = res.body || {};
          if (this.isApiSuccess(body.error)) {
            this.privilegeConfigList = body.data || [];
          } else {
            console.warn(LOG_TAG, "privilegeConfigs fail", body);
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "privilegeConfigs error", err);
        });
    },
    handleQuery() {
      this.queryForm.pageNum = 1;
      this.fetchList();
    },
    fetchList() {
      const payload = {
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize,
      };
      const prizeId = (this.queryForm.prizeId || "").trim();
      if (prizeId && /^\d+$/.test(prizeId)) {
        payload.id = Number(prizeId);
      }
      const prizeName = (this.queryForm.prizeName || "").trim();
      if (prizeName) {
        payload.name = prizeName;
      }
      const prizeType = this.queryForm.prizeType;
      if (prizeType !== "" && prizeType !== null && prizeType !== undefined) {
        payload.type = Number(prizeType);
      }
      const status = this.queryForm.status;
      if (status !== "" && status !== null && status !== undefined) {
        payload.status = Number(status);
      }

      this.listLoading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/prize/v70310/list",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "list fail", body);
            this.$util.errorMsg(body.message || "查询失败");
            this.tableData = [];
            this.tableTotal = 0;
            return;
          }
          const data = body.data || {};
          this.tableTotal = data.total != null ? data.total : 0;
          this.tableData = (data.list || []).map((r) => this.mapRow(r));
        })
        .catch((err) => {
          console.warn(LOG_TAG, "list error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
          this.tableData = [];
          this.tableTotal = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    resetQuery() {
      this.queryForm = {
        prizeId: "",
        prizeName: "",
        prizeType: "",
        status: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.fetchList();
    },
    // 新增奖品
    handleAdd() {
      this.addDialogVisible = true;
    },
    onPrizeTypeChange() {
      this.addForm.cardRefId = null;
      this.addForm.medalUrl = "";
      this.addForm.physicalUrl = "";
      this.addForm.avatarId = null;
      this.addForm.avatarName = "";
      this.addForm.avatarUrl = "";
      this.addForm.themeId = null;
      this.addForm.themeName = "";
      this.addForm.themeUrl = "";
      this.addForm.outerType = null;
      this.addForm.appId = "";
      this.addForm.path = "";
      this.addForm.isPopup = 0;
      this.addForm.popupContent = "";
      this.addForm.prizeImage = "";
      this.addForm.outerUrl = "";
      if (this.addForm.prizeType === 0) {
        this.privilegeConfigList = [];
        this.fetchPrivilegeConfigs();
      }
    },
    // 外链类型切换：清空其下游字段
    onOuterTypeChange() {
      this.addForm.appId = "";
      this.addForm.path = "";
      this.addForm.isPopup = 0;
      this.addForm.popupContent = "";
      this.addForm.outerUrl = "";
    },
    resetAddForm() {
      this.addForm = {
        prizeName: "",
        prizeType: null,
        cardRefId: null,
        medalUrl: "",
        physicalUrl: "",
        avatarId: null,
        avatarName: "",
        avatarUrl: "",
        themeId: null,
        themeName: "",
        themeUrl: "",
        outerType: null,
        appId: "",
        path: "",
        isPopup: 0,
        popupContent: "",
        prizeImage: "",
        outerUrl: "",
      };
    },
    confirmAdd() {
      if (!this.addForm.prizeName) {
        this.$message.warning("请输入奖品名称");
        return;
      }
      if (this.addForm.prizeType === null || this.addForm.prizeType === "") {
        this.$message.warning("请选择奖品类型");
        return;
      }
      const type = Number(this.addForm.prizeType);
      const payload = { name: this.addForm.prizeName, type };

      if (type === 0) {
        if (!this.addForm.cardRefId) {
          this.$message.warning("请选择赠送卡");
          return;
        }
        payload.refId = this.addForm.cardRefId;
      } else if (type === 1) {
        if (!this.addForm.avatarId) {
          this.$message.warning("请选择头像挂件");
          return;
        }
        payload.refId = this.addForm.avatarId;
      } else if (type === 2) {
        if (!this.addForm.themeId) {
          this.$message.warning("请选择主题");
          return;
        }
        payload.refId = this.addForm.themeId;
      } else if (type === 4) {
        if (!this.addForm.medalUrl) {
          this.$message.warning("请上传奖牌图片");
          return;
        }
        payload.detail = this.addForm.medalUrl;
      } else if (type === 5) {
        if (!this.addForm.physicalUrl) {
          this.$message.warning("请上传奖品图片");
          return;
        }
        payload.detail = this.addForm.physicalUrl;
      } else if (type === 6) {
        if (!this.addForm.prizeImage) {
          this.$message.warning("请上传奖励图片");
          return;
        }
        if (!this.addForm.outerType) {
          this.$message.warning("请选择外链类型");
          return;
        }
        if (this.addForm.outerType === 7) {
          if (!this.addForm.appId) {
            this.$message.warning("请输入小程序原始ID");
            return;
          }
          if (!this.addForm.path) {
            this.$message.warning("请输入小程序路径");
            return;
          }
        } else if (this.addForm.outerType === 5) {
          if (!this.addForm.outerUrl) {
            this.$message.warning("请填写外链地址");
            return;
          }
        }
        if (this.addForm.isPopup === 1 && !this.addForm.popupContent) {
          this.$message.warning("请填写弹窗内容");
          return;
        }
        payload.outerType = this.addForm.outerType;
        payload.isPopup = Number(this.addForm.isPopup);
        if (this.addForm.isPopup === 1) {
          payload.popupContent = this.addForm.popupContent;
        }
        // 奖励图片存 detail 字段（外链奖励下 detail 含义为图片 URL）
        payload.detail = this.addForm.prizeImage;
        if (this.addForm.outerType === 7) {
          // 微信小程序：将 AppID 与路径拼成 id=appId&path=path 存入 outerUrl
          payload.outerUrl = this.buildOuterDetail(
            this.addForm.appId,
            this.addForm.path
          );
        } else if (this.addForm.outerType === 5) {
          // 跳转URL：跳转地址直接存 outerUrl
          payload.outerUrl = this.addForm.outerUrl;
        }
      }

      this.addLoading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/prize/v70310/add",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "add fail", body);
            this.$util.errorMsg(body.message || "新增失败");
            return;
          }
          this.$message.success("新增成功");
          this.addDialogVisible = false;
          this.handleQuery();
        })
        .catch((err) => {
          console.warn(LOG_TAG, "add error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    // 选择头像挂件
    handleSelectAvatar() {
      this.selectedAvatarId = this.addForm.avatarId;
      this.avatarSearchName = "";
      this.avatarPageNum = 1;
      this.avatarDialogVisible = true;
      this.fetchAvatarList();
    },
    fetchAvatarList() {
      this.avatarLoading = true;
      const params = {
        businessType: 2,
        status: 3,
        pageNumber: this.avatarPageNum,
        pageSize: this.avatarPageSize,
      };
      if (this.avatarSearchName.trim()) {
        params.name = this.avatarSearchName.trim();
      }
      this.$http({
        method: "get",
        url: this.$util.domain + DIY_LIST_URL,
        params,
      })
        .then((res) => {
          const data = res.data || res.body || {};
          if (data.error !== 10000) {
            console.warn(LOG_TAG, "avatarList fail", data);
            this.$util.errorMsg(data.message || "加载失败");
            this.avatarList = [];
            this.avatarTotal = 0;
            return;
          }
          const result = data.data || {};
          this.avatarTotal = result.count || 0;
          this.avatarList = (result.resModels || []).map((item) => ({
            id: item.id,
            name: item.name,
            url: item.content || "",
          }));
        })
        .catch((err) => {
          console.warn(LOG_TAG, "avatarList error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
          this.avatarList = [];
          this.avatarTotal = 0;
        })
        .finally(() => {
          this.avatarLoading = false;
        });
    },
    onAvatarSearch() {
      this.avatarPageNum = 1;
      this.fetchAvatarList();
    },
    onAvatarPageChange(page) {
      this.avatarPageNum = page;
      this.fetchAvatarList();
    },
    onAvatarRowClick(row) {
      this.selectedAvatarId = row.id;
    },
    confirmAvatar() {
      if (!this.selectedAvatarId) {
        this.$message.warning("请选择头像挂件");
        return;
      }
      const selected = this.avatarList.find(
        (item) => item.id === this.selectedAvatarId
      );
      if (selected) {
        this.addForm.avatarId = selected.id;
        this.addForm.avatarName = selected.name;
        this.addForm.avatarUrl = selected.url;
      }
      this.avatarDialogVisible = false;
    },
    // 选择主题
    handleSelectTheme() {
      this.selectedThemeId = this.addForm.themeId;
      this.themeSearchName = "";
      this.themePageNum = 1;
      this.themeDialogVisible = true;
      this.fetchThemeList();
    },
    fetchThemeList() {
      this.themeLoading = true;
      const params = {
        businessType: 1,
        status: 3,
        pageNumber: this.themePageNum,
        pageSize: this.themePageSize,
      };
      if (this.themeSearchName.trim()) {
        params.name = this.themeSearchName.trim();
      }
      this.$http({
        method: "get",
        url: this.$util.domain + DIY_LIST_URL,
        params,
      })
        .then((res) => {
          const data = res.data || res.body || {};
          if (data.error !== 10000) {
            console.warn(LOG_TAG, "themeList fail", data);
            this.$util.errorMsg(data.message || "加载失败");
            this.themeList = [];
            this.themeTotal = 0;
            return;
          }
          const result = data.data || {};
          this.themeTotal = result.count || 0;
          this.themeList = (result.resModels || []).map((item) => {
            const firstIcon = (item.homeIcon && item.homeIcon[0]) || {};
            const previewUrl =
              firstIcon.backgroundImage ||
              firstIcon.homeBackgroundImage ||
              firstIcon.iconNormal ||
              item.content ||
              "";
            return {
              id: item.id,
              name: item.name,
              url: previewUrl,
              homeIcon: item.homeIcon || [],
              superscript: item.superscript || "",
            };
          });
        })
        .catch((err) => {
          console.warn(LOG_TAG, "themeList error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
          this.themeList = [];
          this.themeTotal = 0;
        })
        .finally(() => {
          this.themeLoading = false;
        });
    },
    onThemeSearch() {
      this.themePageNum = 1;
      this.fetchThemeList();
    },
    onThemePageChange(page) {
      this.themePageNum = page;
      this.fetchThemeList();
    },
    onThemeRowClick(row) {
      this.selectedThemeId = row.id;
    },
    confirmTheme() {
      if (!this.selectedThemeId) {
        this.$message.warning("请选择主题");
        return;
      }
      const selected = this.themeList.find(
        (item) => item.id === this.selectedThemeId
      );
      if (selected) {
        this.addForm.themeId = selected.id;
        this.addForm.themeName = selected.name;
        this.addForm.themeUrl = selected.url;
      }
      this.themeDialogVisible = false;
    },
    uploadPrizeImage(file, onSuccess) {
      if (!file || !file.raw) return;
      const formData = new FormData();
      formData.append("uploadFile", file.raw, file.name || "prize.jpg");
      const uploadUrl =
        this.$util.domain +
        "/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1";
      const headers = {
        Authorization: "Bearer " + (localStorage.getItem("token") || ""),
      };
      this.$http({ method: "POST", url: uploadUrl, body: formData, headers })
        .then((res) => {
          const body = res.body || res.data || {};
          if (body.error !== 10000 && body.error !== 0) {
            console.warn(LOG_TAG, "upload prize image fail", body);
            this.$util.errorMsg(body.message || "图片上传失败");
            return;
          }
          const raw = body.data;
          const url =
            typeof raw === "string"
              ? raw.trim()
              : raw && typeof raw.url === "string"
              ? raw.url.trim()
              : "";
          if (url) {
            onSuccess(url);
          } else {
            this.$util.errorMsg("上传失败，未获取到图片地址");
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "upload prize image error", err);
          this.$util.errorMsg("图片上传失败，请重试");
        });
    },
    onMedalChange(file) {
      this.uploadPrizeImage(file, (url) => {
        this.addForm.medalUrl = url;
      });
    },
    // 查看
    handleView(row) {
      this.currentRow = row;
      this.viewDialogVisible = true;
      // 外链奖励需调详情接口补全字段（outerType/appId/path/isPopup/popupContent）
      if (row.prizeType === 6) {
        this.fetchOuterDetail(row.prizeId);
      }
    },
    // 外链奖励详情：/adminapi/competition/prize/v70310/detail
    fetchOuterDetail(id) {
      this.viewLoading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/prize/v70310/detail",
        method: "GET",
        params: { id },
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "prize detail fail", body);
            this.$util.errorMsg(body.message || "查询详情失败");
            return;
          }
          const data = body.data || {};
          const merged = Object.assign({}, this.currentRow);
          // 字段兼容：后端契约以 MCP 文档为准（此处兼容多种可能字段名）
          if (data.outerType !== undefined) merged.outerType = data.outerType;
          if (data.isPopup !== undefined) merged.isPopup = data.isPopup;
          if (data.popupContent !== undefined)
            merged.popupContent = data.popupContent;
          // appId / path / outerUrl 可能直接作为字段返回，也可能编码在 detail 中
          if (data.appId !== undefined) merged.appId = data.appId;
          if (data.path !== undefined) merged.path = data.path;
          if (data.outerUrl !== undefined) merged.outerUrl = data.outerUrl;
          if (data.detail) {
            const parsed = this.parseOuterDetail(data.detail);
            // 仅当 detail 确实编码了 appId/path 时才回填（新数据 detail 为图片 URL，不覆盖独立字段）
            if (parsed.appId) merged.appId = parsed.appId;
            if (parsed.path) merged.path = parsed.path;
          }
          this.currentRow = merged;
        })
        .catch((err) => {
          console.warn(LOG_TAG, "prize detail error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.viewLoading = false;
        });
    },
    // 停用/启用
    handleChangeStatus(row, targetStatus) {
      this.currentRow = row;
      this.pendingStatus = targetStatus;
      this.disableDialogVisible = true;
    },
    confirmDisable() {
      if (!this.currentRow) return;
      const id = this.currentRow.prizeId;
      const status = this.pendingStatus;
      this.disableLoading = true;
      this.$http({
        url:
          this.$util.domain + "/adminapi/competition/prize/v70310/changeStatus",
        method: "POST",
        body: JSON.stringify({ id, status }),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "changeStatus fail", body);
            this.$util.errorMsg(
              body.message || (status === 0 ? "停用失败" : "启用失败")
            );
            return;
          }
          this.$message.success(status === 0 ? "停用成功" : "启用成功");
          this.disableDialogVisible = false;
          this.currentRow = null;
          this.fetchList();
        })
        .catch((err) => {
          console.warn(LOG_TAG, "changeStatus error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.disableLoading = false;
        });
    },
    // 外链奖励：将 appId 与 path 组装为 key=value 形式的 detail（id=...&path=...）
    buildOuterDetail(appId, path) {
      return "id=" + (appId || "") + "&path=" + (path || "");
    },
    // 外链奖励：回显解析 detail。兼容两种格式：
    //  1) key=value 文本：id=...&path=...（前端保存格式）
    //  2) 后端可能把 appId/path 存为 JSON 对象/字符串：{"id":..,"path":..} 或 {"appId":..,"path":..}
    parseOuterDetail(detail) {
      if (!detail) return { appId: "", path: "" };
      // 先尝试 JSON 形式（后端将字段存为对象时）
      try {
        const obj = typeof detail === "string" ? JSON.parse(detail) : detail;
        if (
          obj &&
          typeof obj === "object" &&
          (obj.id !== undefined ||
            obj.appId !== undefined ||
            obj.path !== undefined)
        ) {
          return {
            appId: obj.appId !== undefined ? obj.appId : obj.id,
            path: obj.path || "",
          };
        }
      } catch (_) {
        // 非 JSON，继续走 key=value 文本解析
      }
      const str = String(detail);
      const result = { appId: "", path: "" };
      const idMatch = str.match(/id=([^&]*)/);
      const pathMatch = str.match(/path=(.*)$/);
      if (idMatch) result.appId = idMatch[1];
      if (pathMatch) result.path = pathMatch[1];
      return result;
    },
    previewImage(src) {
      this.previewSrc = src;
      this.previewVisible = true;
    },
  },
};
</script>

<style scoped>
.same-width-input {
  width: 320px;
}
.prize-manage {
  padding: 20px;
}
.page-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  height: 56px;
  margin-bottom: 20px;
  padding: 0 16px;
  background-color: #f5f7fa;
  box-sizing: border-box;
}
.page-header__title {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 56px;
  height: 56px;
  overflow: hidden;
}
.search-form {
  margin-bottom: 15px;
}
.pagination {
  margin-bottom: 15px;
}
.el-pagination {
  margin-top: 15px;
  text-align: right;
}
.status-enabled {
  color: #67c23a;
}
.status-disabled {
  color: #f56c6c;
}
.detail-text {
  text-align: left;
  padding: 4px 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}
.detail-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
}
.detail-icon-img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.detail-img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}
.view-detail {
  line-height: 2;
}
.view-row {
  margin-bottom: 4px;
}
.view-outer > div {
  margin: 2px 0;
}
.view-label {
  color: #909399;
  display: inline-block;
  min-width: 80px;
  text-align: right;
  margin-right: 8px;
}
.add-form {
  padding: 10px 20px 0 0;
}
.type-warning {
  color: #f56c6c;
  font-size: 13px;
  line-height: 1.6;
}
.cert-tip {
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
  padding: 10px 0;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.4;
}
.prize-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 148px;
  height: 148px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.prize-uploader >>> .el-upload:hover {
  border-color: #409eff;
}
.prize-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.prize-preview {
  width: 148px;
  height: 148px;
  object-fit: contain;
  display: block;
}
/* 外链奖励的奖励图片：加外边框以与占位框区分 */
.prize-preview--bordered {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px;
  background: #fff;
  box-sizing: border-box;
}
/* 选择弹窗搜索行 */
.select-dialog-search {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.select-dialog-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.select-list-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  vertical-align: middle;
}
.theme-img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  justify-content: center;
}
.selected-preview {
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.selected-img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin-right: 10px;
}
.selected-name {
  color: #606266;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// matchPrizeManage.vue?5aa265fa